import script from "./EditNoteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditNoteModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditNoteModal.vue?vue&type=style&index=0&id=0b4d15c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b4d15c7"]])

export default __exports__